'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ROW_TYPE = exports.ROW_TYPE = 'row';
var LIST_TYPE = exports.LIST_TYPE = 'list';


//////////////////
// WEBPACK FOOTER
// ./~/react-virtual-kanban/lib/types.js
// module id = 356
// module chunks = 0